


























import {Component, Watch, Prop, Mixins} from 'vue-property-decorator'
import _ from 'lodash'
import {MixinUpload} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import * as Helper from '@/helpers'
import {FileObject} from 'image-compressor.js'
import {AppConfig} from '@/config/app.config'
import CargaRequest from '@/model/request/CargaRequest'
import Carga from '@/model/resource/Carga'

@Component
export default class ItDriverAssociationCsvUpload extends Mixins(MixinUpload) {
  @Prop({type: Array, required: true}) value!: CargaRequest[]

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset()

  @Watch('files')
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    const blueprint = AppConfig.csvBlueprint.queryDriverAssociation
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    const result = _(data)
      .groupBy('idMotorista')
      .map((val, key) => {
        const request = new CargaRequest() as CargaRequest
        const idMotorista = Number(key)

        if (isNaN(idMotorista)) {
          Helper.abort('system.error.wrongFormat')
        }

        request.ids = val.map((item) => {
          const id = Number(item.idCarga)
          if (isNaN(id)) {
            Helper.abort('system.error.wrongFormat')
          }
          return id
        })

        request.item = new Carga() as Carga
        request.item.idMotoristaFk = idMotorista

        return request
      }).value()

    this.$emit('input', result)
    this.files = []
  }
}
